import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgDistribution(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 0 18 24" {...props}>
      <path
        d="M14.962 17.205l-.625-.59-1.914 1.807V13.23h-.846v5.19l-1.914-1.806-.625.59L12 20zm2.243-8.167l-.59.625 1.807 1.914H13.23v.846h5.19l-1.806 1.914.59.625L20 12zm-10.41 0l.59.625-1.807 1.914h5.191v.846H5.58l1.806 1.914-.59.625L4 12zm8.167-2.243l-.625.59-1.914-1.807v5.191h-.846V5.58L9.663 7.384l-.625-.59L12 4z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.75}
      />
    </svg>
  );
}

export default tombacIcon('Distribution')(SvgDistribution);
